import React, {useState, useEffect, useMemo} from "react";
import {post} from "aws-amplify/api";
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter,
  Row,
  Col,
  Alert
} from "reactstrap";
import {Form, FormGroup, Input, Label} from "reactstrap";
import {BackgroundColorContext} from "../../contexts/BackgroundColorContext";
import {useForm, Controller} from "react-hook-form";
import {useUser} from "../../contexts/AuthContext";
import {usePayment} from "../../contexts/PaymentContext";
import {useSettings} from "../../contexts/SettingsContext";
import toast from "react-hot-toast";

const options: any[] = [
  {label: "(GMT-12:00) International Date Line West", value: "-12"},
  {label: "(GMT-11:00) Midway Island, Samoa", value: "-11"},
  {label: "(GMT-10:00) Hawaii", value: "-10"},
  {label: "(GMT-09:00) Alaska", value: "-9"},
  {label: "(GMT-08:00) Pacific Time (US & Canada)", value: "-8"},
  {label: "(GMT-08:00) Tijuana, Baja California", value: "-8"},
  {label: "(GMT-07:00) Arizona", value: "-7"},
  {label: "(GMT-07:00) Chihuahua, La Paz, Mazatlan", value: "-7"},
  {label: "(GMT-07:00) Mountain Time (US & Canada)", value: "-7"},
  {label: "(GMT-06:00) Central America", value: "-6"},
  {label: "(GMT-06:00) Central Time (US & Canada)", value: "-6"},
  {label: "(GMT-05:00) Bogota, Lima, Quito, Rio Branco", value: "-5"},
  {label: "(GMT-05:00) Eastern Time (US & Canada)", value: "-5"},
  {label: "(GMT-05:00) Indiana (East)", value: "-5"},
  {label: "(GMT-04:00) Atlantic Time (Canada)", value: "-4"},
  {label: "(GMT-04:00) Caracas, La Paz", value: "-4"},
  {label: "(GMT-04:00) Manaus", value: "-4"},
  {label: "(GMT-04:00) Santiago", value: "-4"},
  {label: "(GMT-03:30) Newfoundland", value: "-3.5"},
  {label: "(GMT-03:00) Brasilia", value: "-3"},
  {label: "(GMT-03:00) Buenos Aires, Georgetown", value: "-3"},
  {label: "(GMT-03:00) Greenland", value: "-3"},
  {label: "(GMT-03:00) Montevideo", value: "-3"},
  {label: "(GMT-02:00) Mid-Atlantic", value: "-2"},
  {label: "(GMT-01:00) Cape Verde Is.", value: "-1"},
  {label: "(GMT-01:00) Azores", value: "-1"},
  {label: "(GMT+00:00) Casablanca, Monrovia, Reykjavik", value: "0"},
  {label: "(GMT+00:00) Greenwich Mean Time : Dublin, Edinburgh, Lisbon, London", value: "0"},
  {label: "(GMT+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna", value: "1"},
  {label: "(GMT+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague", value: "1"},
  {label: "(GMT+01:00) Brussels, Copenhagen, Madrid, Paris", value: "1"},
  {label: "(GMT+01:00) Sarajevo, Skopje, Warsaw, Zagreb", value: "1"},
  {label: "(GMT+01:00) West Central Africa", value: "1"},
  {label: "(GMT+02:00) Amman", value: "2"},
  {label: "(GMT+02:00) Athens, Bucharest, Istanbul", value: "2"},
  {label: "(GMT+02:00) Beirut", value: "2"},
  {label: "(GMT+02:00) Cairo", value: "2"},
  {label: "(GMT+02:00) Harare, Pretoria", value: "2"},
  {label: "(GMT+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius", value: "2"},
  {label: "(GMT+02:00) Jerusalem", value: "2"},
  {label: "(GMT+02:00) Minsk", value: "2"},
  {label: "(GMT+02:00) Windhoek", value: "2"},
  {label: "(GMT+03:00) Kuwait, Riyadh, Baghdad", value: "3"},
  {label: "(GMT+03:00) Moscow, St. Petersburg, Volgograd", value: "3"},
  {label: "(GMT+03:00) Nairobi", value: "3"},
  {label: "(GMT+03:00) Tbilisi", value: "3"},
  {label: "(GMT+03:30) Tehran", value: "3.5"},
  {label: "(GMT+04:00) Abu Dhabi, Muscat", value: "4"},
  {label: "(GMT+04:00) Baku", value: "4"},
  {label: "(GMT+04:00) Yerevan", value: "4"},
  {label: "(GMT+04:30) Kabul", value: "4.5"},
  {label: "(GMT+05:00) Yekaterinburg", value: "5"},
  {label: "(GMT+05:00) Islamabad, Karachi, Tashkent", value: "5"},
  {label: "(GMT+05:30) Sri Jayawardenapura", value: "5.5"},
  {label: "(GMT+05:30) Chennai, Kolkata, Mumbai, New Delhi", value: "5.5"},
  {label: "(GMT+05:45) Kathmandu", value: "5.75"},
  {label: "(GMT+06:00) Almaty, Novosibirsk", value: "6"},
  {label: "(GMT+06:00) Astana, Dhaka", value: "6"},
  {label: "(GMT+06:30) Yangon (Rangoon)", value: "6.5"},
  {label: "(GMT+07:00) Bangkok, Hanoi, Jakarta", value: "7"},
  {label: "(GMT+07:00) Krasnoyarsk", value: "7"},
  {label: "(GMT+08:00) Beijing, Chongqing, Hong Kong, Urumqi", value: "8"},
  {label: "(GMT+08:00) Kuala Lumpur, Singapore", value: "8"},
  {label: "(GMT+08:00) Irkutsk, Ulaan Bataar", value: "8"},
  {label: "(GMT+08:00) Perth", value: "8"},
  {label: "(GMT+08:00) Taipei", value: "8"},
  {label: "(GMT+09:00) Osaka, Sapporo, Tokyo", value: "9"},
  {label: "(GMT+09:00) Seoul", value: "9"},
  {label: "(GMT+09:00) Yakutsk", value: "9"},
  {label: "(GMT+09:30) Adelaide", value: "9.5"},
  {label: "(GMT+09:30) Darwin", value: "9.5"},
  {label: "(GMT+10:00) Brisbane", value: "10"},
  {label: "(GMT+10:00) Canberra, Melbourne, Sydney", value: "10"},
  {label: "(GMT+10:00) Hobart", value: "10"},
  {label: "(GMT+10:00) Guam, Port Moresby", value: "10"},
  {label: "(GMT+10:00) Vladivostok", value: "10"},
  {label: "(GMT+11:00) Magadan, Solomon Is., New Caledonia", value: "11"},
  {label: "(GMT+12:00) Auckland, Wellington", value: "12"},
  {label: "(GMT+12:00) Fiji, Kamchatka, Marshall Is.", value: "12"},
  {label: "(GMT+13:00) Nuku'alofa", value: "13"}
];

const SettingsModal: React.FC = () => {
  const {user, refreshJwt} = useUser();
  const {getTokenBalance} = usePayment();
  const {isModalOpen, closeSettings} = useSettings();
  const [, setReactSelect] = useState(null);
  const [skipAnalysisConfirmation, setSkipAnalysisConfirmation] = useState(false);

  // Memoize the initial selected option based on user settings
  const initialSelected = useMemo(() => {
    const timezoneOffsetHours: string = `${Math.floor(user.settings.timezoneOffsetMinutes / 60)}`;
    const initialSelectedOptions: any | undefined = options.find((x: any) => x.value === timezoneOffsetHours);

    if (initialSelectedOptions !== undefined) {
      return initialSelectedOptions;
    } else {
      // GMT
      return options.find((x: any) => x.value === "0");
    }
  }, [user.settings.timezoneOffsetMinutes]);

  const {control, handleSubmit, getValues, reset} = useForm({
    defaultValues: {
      reactSelect: initialSelected
    }
  });

  useEffect(() => {
    // Reset form with updated timezone when settings load or change
    reset({
      reactSelect: initialSelected
    });
    setReactSelect(initialSelected);
  }, [initialSelected, reset]);

  useEffect(() => {
    // Refresh token balance when Settings modal opens
    if (user.authenticated && isModalOpen) {
      getTokenBalance();
    }
    // Check if user has disabled analysis confirmation
    const skipConfirmation = localStorage.getItem("zwiftalizer_skip_analysis_confirmation") === "true";
    setSkipAnalysisConfirmation(skipConfirmation);
  }, [isModalOpen]);

  const handleResetAnalysisConfirmation = () => {
    localStorage.removeItem("zwiftalizer_skip_analysis_confirmation");
    setSkipAnalysisConfirmation(false);
    toast.success("Analysis confirmation preference has been reset");
  };

  const handleCancel = () => {
    // Reset form to initial values
    reset({
      reactSelect: initialSelected
    });
    closeSettings();
  };

  async function onSubmit(formData: any) {
    try {
      const selectedOptions = getValues("reactSelect");

      if (selectedOptions !== undefined) {
        const timezoneOffsetHours: number = parseInt(selectedOptions["value"]);
        const timezoneOffsetMinutes: number = timezoneOffsetHours * 60;
        user.settings.timezoneOffsetMinutes = timezoneOffsetMinutes;
      }

      await refreshJwt(user);

      const params: any = {
        headers: {
          Authorization: user.jwtToken
        },
        body: user.settings
      };

      const userId: string = user.identityId as string;

      await post({
        apiName: "app",
        path: `/settings/${userId}`,
        options: params
      });

      toast.success("Settings saved successfully");
      closeSettings();
    } catch {
      toast.error("Failed to save settings");
      return undefined;
    }
  }

  return (
    <BackgroundColorContext.Consumer>
      {({color}) => (
        <Modal isOpen={isModalOpen} toggle={closeSettings} size="lg" className="settings-modal">
          <ModalHeader>
            <button aria-label="Close" className="close" onClick={closeSettings}>
              <i className="fa fa-times" />
            </button>
          </ModalHeader>
          <ModalBody>
            <Card>
              <CardHeader data-color={color}>
                <CardTitle tag="h3">
                  <i className="fa fa-cog mr-2" />
                  Settings
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <FormGroup>
                    <Label>Timezone</Label>
                    <Controller
                      name="reactSelect"
                      control={control}
                      render={({field}) => (
                        <Input
                          type="select"
                          className="form-control"
                          data-color={color}
                          value={field.value?.value || ""}
                          onChange={(e) => {
                            const selectedOption = options.find((opt) => opt.value === e.target.value);
                            field.onChange(selectedOption);
                            setReactSelect(selectedOption);
                          }}
                        >
                          {options.map((option) => (
                            <option key={option.value} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </Input>
                      )}
                    />
                  </FormGroup>

                  <hr />

                  <Row>
                    <Col md="12">
                      <h5 className="mb-3">
                        <i className="fa fa-chart-line mr-2"></i>
                        Advanced Analysis Preferences
                      </h5>
                      {skipAnalysisConfirmation ? (
                        <Alert color="info">
                          <i className="fa fa-info-circle mr-2"></i>
                          You have disabled the confirmation dialog for Advanced Analysis. Analysis will run immediately
                          when you click the "Analyze" button.
                        </Alert>
                      ) : (
                        <Alert color="success">
                          <i className="fa fa-check-circle mr-2"></i>
                          Confirmation dialog is enabled. You will be asked to confirm before running Advanced Analysis.
                        </Alert>
                      )}
                      <Button
                        color="primary"
                        data-color={color}
                        onClick={handleResetAnalysisConfirmation}
                        disabled={!skipAnalysisConfirmation}
                      >
                        <i className="fa fa-undo mr-1"></i>
                        Reset Confirmation Preference
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
              <CardFooter>
                <Button color="primary" data-color={color} onClick={handleSubmit(onSubmit)}>
                  Save
                </Button>
                <Button color="secondary" onClick={handleCancel} className="ml-2">
                  Cancel
                </Button>
              </CardFooter>
            </Card>
          </ModalBody>
        </Modal>
      )}
    </BackgroundColorContext.Consumer>
  );
};

export default SettingsModal;
